import React from 'react';

import {
  FAMILY_STANDARD_BOLD,
  FAMILY_EXTENDED_BOLD,
} from 'depop/styles/typography';

import { css } from 'glamor';

function MobileHeaderItem({
  children,
  expanded = false,
  float='none'
}: {
  children: React.Element,
  expanded: boolean,
  float: String,
}) {
  return React.cloneElement(
    children,
    css({
      display: 'inline-block',
      fontSize: 16,
      float: float,
      lineHeight: '20px',
      color: 'inherit',
      textDecoration: 'none',
      fontWeight: 'bold',
      fontFamily: expanded ? FAMILY_EXTENDED_BOLD : FAMILY_STANDARD_BOLD,
      cursor: 'pointer',
      ':hover': {
        textDecoration: 'underline',
      },
    }),
  );
}

export default MobileHeaderItem;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/MobileHeaderItem.js